import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { setNumberOfNewDetectedPatterns } from "../../../../redux/slices/detectedPatterns";

import GridChart from "../GridChart/GridChart";

import { DetectedPatternContainer } from "./DetectedPatternsStyles";
import { GridText } from "../GridStyles";

import { useDetectedPatternData } from "./hooks/useDetectedPatternData";
import AnimatedMessage from "../../../UI/AnimatedMessage/AnimatedMessage";
import filterForDuplicatePatterns from "./utils/filterForDuplicatePatterns";

export default function DetectedPatterns({ selectedPatternData }) {
  const dispatch = useDispatch();

  const detectingPatterns = useSelector(
    ({ detectedPatterns }) => detectedPatterns.fetching
  );
  const patternData = useDetectedPatternData();

  const filteredPatternData = filterForDuplicatePatterns(
    patternData,
    selectedPatternData
  );

  dispatch(setNumberOfNewDetectedPatterns(filteredPatternData.length));

  const noDetectedPatternsStatement = detectingPatterns ? (
    <AnimatedMessage>Detecting</AnimatedMessage>
  ) : (
    "No detected patterns"
  );

  return (
    <DetectedPatternContainer>
      <>
        {filteredPatternData.length ? (
          filteredPatternData.map((pattern, index) => (
            <GridChart
              training={false}
              key={pattern.id}
              pattern={pattern}
              type="detected"
              height={150}
              width={200}
              onClick={() => {}}
            />
          ))
        ) : (
          <GridText>{noDetectedPatternsStatement}</GridText>
        )}
      </>
    </DetectedPatternContainer>
  );
}
